import React, { Fragment, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import cx from "classnames";
import { post } from 'axios';
// Provider
import { AppContext } from "../../../../../components/AppProvider";

// Utils
import { _O } from "../../../../../modules/utils";

// UI
import { IC, Doctor } from "../../../../../resources/Assets";
import { Container, DateLayer, openLayerFn, closeLayerFn, pickerStartFn_day, pickerStartFn_week, pickerStartFn_month, initLayout } from "../../../../Layout";
import { SUBS, SubMenu } from "../../History";
import { fi } from "date-fns/locale";

export default (props) => {
    const {alrmList, alrmTypeCd, setAlrmTypeCd, resetForm, request118, setMdcnId} = props

    // provider
    const { userinfo, cfg, phonecfg } = useContext(AppContext);

    const [statusOnOff, setStatusOnOff] = useState("OFF");

    const checkEmptyValue = (target) => {
      if ($("input[name=mdcnNameInput]").val() === "") {
        if (phonecfg.version == "2.0.31") {
          alert("GR::알림 이름을 먼저 입력하세요.");
        } else {
          if (phonecfg.phoneOS === "IOS") {
            alert("알림 이름을 먼저 입력하세요.");
          } else {
            alert("GR::알림 이름을 먼저 입력하세요.");
          }
        }
        // alert("알림 이름을 먼저 입력하세요.");
        // $("input[name=mdcnNameInput]").focus();
        return 1;
      }

      if (target === "PERIOD") {
        if ($(".select-custom-box").find("a.btn-select").html() === "알림 방법을 선택하세요.") {
          setStatusOnOff("ON");
          alert("알람 형식을 선택해주세요.");
          return 1;
        }
      }
      return 0;
    };

    const openAlrmLayer = () => {
        if(checkEmptyValue() === 0) {
            if(statusOnOff === "ON") {
                setStatusOnOff("OFF");
            } else {
                setStatusOnOff("ON");
            }
        }
    }

    const settingAlrmType = (type, text) => {
        setStatusOnOff("OFF");
        setAlrmTypeCd(type);
        $("#alrmTypeCd").val(type);
        $("#selectCustomBox").find("a.btn-select").html(text);
    }

    const setupToUpdate = (mdcnNm, text, alrmTypeCd, mdcnCyclCd, mdcnId, mdcnCyclVal, mdcnCyclDtlCd, mdcnTime) => {
        // 일단 초기화
        resetForm();

        //  데이터 세팅
        $("#mode").val("MOD");
        // 약 이름
        $("input[name=mdcnNameInput]").val(mdcnNm);
        // 알람 설정 초기화
        $(".select-custom-box").find("a.btn-select").html(text);
        $(".select-gray-enable a.btn-select").removeClass("gray");

        // hidden값 셋팅
        $("#alrmTypeCd").val(alrmTypeCd);
        $("#mdcnCyclCd").val(mdcnCyclCd);
        $("#mdcnCyclVal").val(mdcnCyclVal);
        $("#mdcnCyclDtlCd").val(mdcnCyclDtlCd);
        $("#mdcnTime").val(mdcnTime);
        $("#mdcnId").val(mdcnId);

        // 날짜 주기 on, off
        if(mdcnCyclCd === "01") {
            $(".btn-day-set-layer").addClass("on");
        }

        if(mdcnCyclCd === "02") {
            $(".btn-week-set-layer").addClass("on");
        }

        if(mdcnCyclCd === "03") {
            $(".btn-month-set-layer").addClass("on");
        }

        // 확인 버튼 보이기
        $("#resetForm").show();
    }
    // 폼 리셋 끝

    const removeAlrmList = (mdcnId) => {
        // 삭제하겠습니까? 확인
        // request112(userinfo, cfg, mdcnId, "BP");
        setMdcnId(mdcnId);
        openLayerFn($(".confirm-layer"));
    }
    // 알람 리스트 삭제 끝

    useEffect(() => {
        $("body").click(function (e) {
            if ($(".select-custom-box").hasClass("on")) {
                if (!$(".select-custom-box").has(e.target).length) {
                    setStatusOnOff("OFF");
                }
            }
        });

        //복약정보 완료/수정 토글
        $(".toggle-cmm a").click(function () {
            $(this).toggleClass("off");
        });

        $(".select-gray-enable ul li a").click(function () {
            $(".select-gray-enable a.btn-select").removeClass("gray");
        });

        //알림 방법을 선택하세요. 셀렉트 박스 첫번째칸 표시(선택전 회색표시)
        $("select.selectbox").change(function () {
            var selectidx = this.selectedIndex;
            if (selectidx > 0) $(this).removeClass("dis");
            else $(this).addClass("dis");
        });

        $(".btn-day-set-layer").click(function(){
            if(checkEmptyValue("PERIOD") === 0) {
                $(".check-cycle-date a").removeClass("on");
                $(".btn-day-set-layer").addClass("on");
                
                openLayerFn($(".day-set-layer"));
                pickerStartFn_day($("#mdcnCyclDtlCd").val(), $("#mdcnTime").val());
            }
        });
        
        $(".btn-week-set-layer").click(function(){
            if(checkEmptyValue("PERIOD") === 0) {
                $(".check-cycle-date a").removeClass("on");
                $(".btn-week-set-layer").addClass("on");

                openLayerFn($(".week-set-layer"));
                pickerStartFn_week($("#mdcnCyclDtlCd").val(), $("#mdcnTime").val(), $("#mdcnCyclVal").val());
            }
        });
        
        $(".btn-month-set-layer").click(function(){
            if(checkEmptyValue("PERIOD") === 0) {
                $(".check-cycle-date a").removeClass("on");
                $(".btn-month-set-layer").addClass("on");
                openLayerFn($(".month-set-layer"));
                pickerStartFn_month($("#mdcnCyclDtlCd").val(), $("#mdcnTime").val(), $("#mdcnCyclVal").val());
            }
        });
    }, []);
    return (
      <Fragment>
        <div className="section-box">
          <div className="medic-input-page">
            <input type="hidden" id="mode" defaultValue="ADD" />
            <input type="hidden" id="alrmTypeCd" />
            <input type="hidden" id="mdcnCyclCd" />
            <input type="hidden" id="mdcnCyclVal" />
            <input type="hidden" id="mdcnCyclDtlCd" />
            <input type="hidden" id="mdcnTime" />
            <input type="hidden" id="mdcnId" />

            <div>
              <input
                type="text"
                className="textbox gray focuscheck"
                name="mdcnNameInput"
                maxLength="20"
                placeholder="알림 이름"
                required="required"
              />
            </div>
            <div>
              <div
                className={
                  statusOnOff === "ON"
                    ? "select-custom-box select-gray-enable on"
                    : "select-custom-box select-gray-enable"
                }
                id="selectCustomBox"
                onClick={() => openAlrmLayer()}>
                <a className="btn-select gray">알림 방법을 선택하세요.</a>
                <ul>
                  <li>
                    <a
                      onClick={() => settingAlrmType("01", "앱푸시")}
                      className={alrmTypeCd === "01" ? "on" : ""}>
                      앱푸시
                    </a>
                  </li>
                  {/* <li>
                                    <a onClick={() => settingAlrmType("02", "알림톡")} className={alrmTypeCd === "02" ? "on" : ""}>알림톡</a>
                                </li>
                                <li>
                                    <a onClick={() => settingAlrmType("03", "앱푸시 + 알림톡")} className={alrmTypeCd === "03" ? "on" : ""}>앱푸시 + 알림톡</a>
                                </li> */}
                  {/* <li>
                    <a
                      onClick={() => settingAlrmType("04", "선택안함")}
                      className={alrmTypeCd === "04" ? "on" : ""}
                    >
                      선택안함
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>

            <div className="device-state-info">
              아래의 복약주기를 선택해주세요.
            </div>

            <div className="check-cycle-date">
              <a className="btn-day-set-layer">
                <i></i>매일
              </a>
              <a className="btn-week-set-layer">
                <i></i>매주
              </a>
              <a className="btn-month-set-layer">
                <i></i>매월
              </a>
            </div>
          </div>
        </div>

        <div className="section-box">
          <div className="alarm-box-list">
            <p>
              <i>!</i>복약하는 만큼 추가할 수 있어요!
            </p>

            {alrmList.length > 0 ? (
              alrmList.map(
                (m, i) =>
                  !!m && (
                    <AlrmList
                      mdcnType={m.mdcnType}
                      mdcnNm={m.mdcnNm}
                      alrmTypeCd={m.alrmTypeCd}
                      mdcnCyclCd={m.mdcnCyclCd}
                      mdcnCyclVal={m.mdcnCyclVal}
                      mdcnCyclDtlCd={m.mdcnCyclDtlCd}
                      mdcnTime={m.mdcnTime}
                      key={i}
                      alrmTypeNm={m.alrmTypeNm}
                      mdcnCyclNm={m.mdcnCyclNm}
                      mdcnCyclDtlNm={m.mdcnCyclDtlNm}
                      mdcnId={m.mdcnId}
                      setupToUpdate={setupToUpdate}
                      removeAlrmList={removeAlrmList}
                    />
                  )
              )
            ) : (
              <div className="before-dot-box">
                <i></i>복약알림을 설정해주세요.
              </div>
            )}
          </div>
        </div>

        {/* <div className="section-box">
                <div className="two-btns-area">
                    <a onClick={resetForm}>취소</a>
                    <a>확인</a>
                </div>
            </div> */}
      </Fragment>
    );
};


const AlrmList = (props) => {
    const {
        mdcnType, mdcnNm, alrmTypeCd
        , mdcnCyclCd, mdcnCyclVal, mdcnCyclDtlCd
        , mdcnTime

        , alrmTypeNm, mdcnCyclNm, mdcnCyclDtlNm
        
        , mdcnId

        , setupToUpdate
        , removeAlrmList
    } = props;

    let mdcnCyclValArr = [];
    let mdcnCyclValNm = "";
    const week = new Array ("일", "월", "화", "수", "목", "금", "토");

    mdcnCyclValArr = mdcnCyclVal.split(",");

    if(mdcnCyclCd === "02") {
        if(mdcnCyclVal != "") {
            for(let i=1; i<8; i++) {
                if(mdcnCyclValArr.indexOf(i.toString()) != -1) {
                    mdcnCyclValNm += week[i-1]+",";
                }
            }

            mdcnCyclValNm = mdcnCyclValNm.substr(0, mdcnCyclValNm.length-1);
        }
    }

    if(mdcnCyclCd === "03") {
        mdcnCyclValNm = mdcnCyclVal + "일";
    }

    const onClickDiv = (e) => {
        // onChangeSelectBox(mdcnNm, alrmTypeNm, alrmTypeCd, mdcnCyclCd, index, mdcnId, mdcnCyclVal, mdcnCyclDtlCd, mdcnTime);
        setupToUpdate(mdcnNm, alrmTypeNm, alrmTypeCd, mdcnCyclCd, mdcnId, mdcnCyclVal, mdcnCyclDtlCd, mdcnTime);

        $(e.target).css("bolderColor", "red");
    }

    return (
        <Fragment>
            <div>
                <div onClick={onClickDiv}>
                    <p>
                        {mdcnNm}
                    </p>
                    <div className="time-alarm">
                        <span>
                            <i className="clock"></i>{mdcnCyclNm} {mdcnCyclValNm} {mdcnCyclDtlNm}, {mdcnTime.substr(0,2)}:{mdcnTime.substr(2,4)}
                        </span>
                        <span>
                            <i className="bell"></i>{alrmTypeNm}
                        </span>
                    </div>
                </div>
                <a onClick={() => removeAlrmList(mdcnId)} className="btn-close"></a>
            </div>
        </Fragment>
    );
}